import CalendarIcon from "@/Icons/Calendar";

import React, { useEffect } from "react";
import { DayPicker, getDefaultClassNames } from "react-day-picker";

import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import moment from "moment";
import { twMerge } from "tailwind-merge";

export const DatePicker: React.FC<{
  onChange: (date?: Date) => void;
  value: Date;
  heading: string;
  minDate?: Date;
}> = ({ onChange, value, heading, minDate }) => {
  useEffect(() => {
    if (minDate && value < minDate) {
      onChange(minDate);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [minDate]);

  const defaultClassNames = getDefaultClassNames();

  return (
    <div>
      <p className="font-dm-sans text-2xs text-grey6 mb-0.5 font-bold">
        {heading}
      </p>
      <Popover className="relative">
        {({ close }) => (
          <>
            <PopoverButton className="bg-grey1 flex w-full flex-row text-sm">
              <div className="m-1.5">
                <CalendarIcon />
              </div>
              <div className="m-1">{moment(value).format("DD/MM/YYYY")}</div>
            </PopoverButton>
            <PopoverPanel className="absolute bg-white p-2 shadow-sm">
              <DayPicker
                mode="single"
                selected={value}
                weekStartsOn={1}
                onSelect={(date) => {
                  onChange(date);
                  close();
                }}
                disabled={{ before: minDate, after: new Date() }}
                startMonth={minDate}
                endMonth={new Date()}
                required={false}
                classNames={{
                  caption_label: twMerge(
                    defaultClassNames.caption_label,
                    "font-dm-sans ",
                  ),
                  weekday: "font-dm-sans text-sm font-normal",
                  disabled: "text-grey3",
                  today: "border-lime",
                  selected: `bg-lime border-lime`,
                  chevron: "fill-black",
                }}
                defaultMonth={value}
              />
            </PopoverPanel>
          </>
        )}
      </Popover>
    </div>
  );
};

export default DatePicker;
